<!-- Clean, intentional design with only 2,4,8 spacing -->
<div class="min-h-screen bg-gradient-to-br from-brand-briefcream via-brand-nude/20 to-brand-briefcream p-4"
  style="background-image: radial-gradient(circle at 1px 1px, rgba(214, 179, 112, 0.15) 1px, transparent 0); background-size: 20px 20px;">
  <div class="max-w-6xl mx-auto">

    <!-- Header -->
    <header class="text-center mb-8 py-8">
      <h1 class="font-[Parisienne] text-3xl text-brand-inktint mb-4">Polterabend-FAQ</h1>
      <div class="flex items-center justify-center space-x-4">
        <div class="w-8 h-px bg-brand-goldline"></div>
        <span class="font-[Neuton] text-xl text-brand-inktint">25. Juli 2026</span>
        <div class="w-8 h-px bg-brand-goldline"></div>
      </div>
      <p class="font-[Neuton] text-brand-inktint/80 mt-4 max-w-2xl mx-auto">
        Scherben bringen Glück - hier findet ihr die wichtigsten Infos.
      </p>
    </header>

    <!-- FAQ Cards -->
    <div class="flex flex-col gap-12">

      <!-- Wann & Wo -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Wann & Wo?</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Ort und Zeit</p>
        </div>

        <!-- Linke Hälfte -->
        <div card-content>
        </div>

        <!-- Rechte Hälfte -->
        <div card-sidebar>
          <p>
            Wir feiern bei Stephans Eltern in Haltern.
          </p>
          <p class="mb-4">
            Start ab <strong>19:00 Uhr</strong> <strong>An der Mühlenstege 49, Haltern</strong>.
            Parkmöglichkeiten sind eingeschränkt.
          </p>
          <a href="https://www.google.com/maps/place/An+d.+M%C3%BChlenstege+49,+45721+Haltern+am+See/@51.7480198,7.1888027,16z"
            target="_blank" rel="noopener" class="underline hover:text-brand-inktint text-brand-inktint">
            Google Maps öffnen
          </a>
        </div>
      </info-card>

      <!-- Buffet -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Essen & Getränke</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Vorbeikommen ist alles</p>
        </div>

        <!-- Linke Hälfte -->
        <div card-content>

        </div>

        <!-- Rechte Hälfte -->
        <div card-sidebar>
          <p class="text-brand-inktint/80 leading-relaxed text-lg">
            Für Getränke und Snacks sorgen wir, bei allem anderen freuen wir uns über Unterstützung.

            Buffetbeiträge sind super - wir pflegen nach und nach ein, was zugesagt ist.
            Schreibt uns also kurz, was ihr mitbringt.
          </p>
        </div>
      </info-card>

      <!-- Begleitung -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Begleitung</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Wer darf mit?</p>
        </div>

        <!-- Linke Hälfte -->
        <div card-content>

        </div>

        <!-- Rechte Hälfte -->
        <div card-sidebar>
          <p class="text-brand-inktint/80 leading-relaxed text-lg">
            Neben euch sind gute Freunde, Partnerinnen/Partner und Fahrer herzlich willkommen. Bitte sagt Bescheid, wer
            euch
            begleitet, damit wir planen können.
          </p>
        </div>
      </info-card>

      <!-- Praktisches -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Praktisches</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Kurz & knapp</p>
        </div>

        <!-- Linke Hälfte -->
        <div card-sidebar>
          <p class="text-brand-inktint/80 leading-relaxed text-lg">
            Wenn ihr Tipps für eine Übernachtung braucht, meldet euch gern. Gleiches gilt für Mitfahrgelegenheiten.
            Vergesst nicht, etwas zu Poltern mitzubringen!
          </p>
        </div>

        <!-- Rechte Hälfte -->
        <div card-content>
        </div>
      </info-card>

      <!-- Mitbringsel -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Mitbringsel</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Was können wir beitragen?</p>
        </div>

        <div card-content></div>

        <div card-sidebar>
          <p class="text-brand-inktint/80 leading-relaxed text-lg">
            Dass ihr kommt und mit uns feiert, ist bereits ein wunderbares Geschenk für uns.
            Darüber hinaus haben wir schon alles, was wir brauchen. Falls ihr uns dennoch eine kleine Freude machen
            möchtet,
            würden wir uns über einen bescheidenen Beitrag zu unserer gemeinsamen Zukunft freuen.
          </p>
        </div>
      </info-card>

    </div>

    <!-- Footer Actions -->
    <footer class="mt-8">
      <div class="flex flex-col gap-12">
        @for (actionCard of actionCards(); track actionCard.title; let i = $index) {
        <action-card [data]="actionCard" [variant]="$even ? 'primary' : 'secondary'">
        </action-card>
        }
      </div>
    </footer>

  </div>
</div>